import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Sidebar from '~COMPONENTS/sidebar/Sidebar';
import AddressBookForm from './AddressBookForm';
import { TranslatedCopy } from '../intl/TranslatedCopy';

import { sidebarOpen, editAddress } from './selectors';
import { requestAddresses } from './actions';
import { setSearchTerm } from '../global/actions';

import { addressTypes } from '../types/address';

export const AddressBookSidebar = ({
  editAddress,
  fetchAddresses,
  handleAddressClick,
  isCheckout,
  setSearchTerm,
  sidebarOpen,
  toggleSidebar
}) => {
  const scrollRef = useRef();
  return (
    <Sidebar
      isOpen={sidebarOpen}
      title={
        editAddress ? (
          <TranslatedCopy id='addressBook.form.edit.title' />
        ) : (
          <TranslatedCopy id='addressBook.form.add.title' />
        )
      }
      closeSidebar={toggleSidebar}
      scrollRef={scrollRef}
    >
      <AddressBookForm
        isOpen={sidebarOpen}
        editAddress={editAddress}
        fetchAddresses={fetchAddresses}
        setSearchTerm={setSearchTerm}
        isCheckout={isCheckout}
        handleAddressClick={handleAddressClick}
        scrollRef={scrollRef}
      />
    </Sidebar>
  );
};

AddressBookSidebar.defaultProps = {
  editAddress: null
};

AddressBookSidebar.propTypes = {
  editAddress: PropTypes.shape(addressTypes),
  fetchAddresses: PropTypes.func.isRequired,
  handleAddressClick: PropTypes.func.isRequired,
  isCheckout: PropTypes.bool.isRequired,
  setSearchTerm: PropTypes.func.isRequired,
  sidebarOpen: PropTypes.bool.isRequired,
  toggleSidebar: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  sidebarOpen: sidebarOpen(state),
  editAddress: editAddress(state)
});

const connector = connect(mapStateToProps, { requestAddresses, setSearchTerm });

export default connector(AddressBookSidebar);
